import React from 'react';

export default function Video({
  accessibilityText = '',
  className = undefined,
  height = '600',
  iframeId = '',
  testId,
  url,
  width = '100%'
}) {
  return url ? (
    <div
      className={className}
      data-testid={testId}
      aria-label={accessibilityText}
    >
      <iframe
        id={iframeId}
        title={accessibilityText}
        type="text/html"
        src={url}
        frameBorder="0"
        // eslint-disable-next-line react/no-unknown-property
        autohide="1"
        width={width}
        height={height}
        allowFullScreen={true}
        webkitallowfullscreen=""
        mozallowfullscreen=""
      ></iframe>
    </div>
  ) : null;
}
